import { GameState } from "../../store";

export default function getHeroWillSitOut({ hero }: GameState) {
  return hero.willSitOut;
}
